import moment from 'moment-timezone'
import { useSelector } from 'react-redux'

import { dateNotationSelector, timeNotationSelector, timezoneSelector } from 'selectors/current_user'
import { userDateTimeFormat } from 'services/time_format'

export const FormattedDateTime = ({ value }) => {
  const timeNotation = useSelector(timeNotationSelector)
  const dateNotation = useSelector(dateNotationSelector)
  const timezone = useSelector(timezoneSelector)

  return userDateTimeFormat(
    moment.tz(value, timezone),
    dateNotation,
    timeNotation,
    'date_time_full'
  )
}
